// 获取元素的绝对位置
const getElementOffset = (element) => {
  const rect = element.getBoundingClientRect();
  return rect.top + window.pageYOffset;
};

// 处理导航项点击事件
const handleNavItemClick = (event) => {
  const currentNavItem = event.currentTarget;
  const buttonContent = currentNavItem.getAttribute("data-name");
  const targetElement = document.querySelector(`[data-id="${buttonContent}"]`);
  
  if (!targetElement) return;
  
  const elementPosition = getElementOffset(targetElement);
  const offset = window.innerWidth <= 1024 ? 70 : 140;

  // 先移除所有导航项的激活状态
  const allNavItems = document.querySelectorAll(".event_nav_item");
  
  allNavItems.forEach((navItem) => {
    navItem.classList.remove("nav_active");
  });

  // 清除所有待执行的延迟移除计时器
  Object.keys(deactivateTimers).forEach((key) => {
    clearTimeout(deactivateTimers[key]);
    delete deactivateTimers[key];
  });

  // 激活所有具有相同 data-name 的导航项
  const allMatchingNavItems = document.querySelectorAll(`[data-name="${buttonContent}"]`);
  
  allMatchingNavItems.forEach((navItem) => {
    navItem.classList.add("nav_active");
  });
  
  // 设置点击滚动标志
  isClickScrolling = true;
  
  window.scrollTo({
    top: elementPosition - offset,
    behavior: "smooth"
    // 注意：原生 scrollTo 不支持 duration 参数，smooth 行为由浏览器控制
  });
  
  // 滚动完成后清除标志（平滑滚动通常在 800-1000ms 内完成）
  setTimeout(() => {
    isClickScrolling = false;
  }, 1000);
};

// 绑定所有导航项的点击事件
const bindNavItemEvents = () => {
  const navItems = document.querySelectorAll(".event_nav_item");
  
  navItems.forEach((navItem) => {
    navItem.addEventListener("click", handleNavItemClick);
  });
};

// 存储待移除激活状态的计时器
let deactivateTimers = {};

// 标志位：是否正在执行点击滚动
let isClickScrolling = false;

// 处理滚动事件，更新导航项高亮状态
const handleScrollHighlight = () => {
  // 如果正在执行点击触发的滚动，则不更新高亮状态
  if (isClickScrolling) {
    return;
  }
  
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const elements = document.querySelectorAll("[data-id]");
  const windowHeight = window.innerHeight;
  
  // 创建一个Set来存储当前应该高亮的导航项
  const activeNavItems = new Set();

  elements.forEach((element) => {
    const tagValue = element.getAttribute("data-id");
    const elementOffset = getElementOffset(element);
    const elementHeight = element.offsetHeight;

    if (
      scrollTop > elementOffset - windowHeight / 2 &&
      scrollTop < elementOffset + elementHeight / 2
    ) {
      // 将应该高亮的导航项添加到Set中
      activeNavItems.add(tagValue);
    }
  });

  // 遍历所有导航项，根据Set中的值来设置高亮状态
  const navItems = document.querySelectorAll("[data-name]");
  
  navItems.forEach((navItem) => {
    const navName = navItem.getAttribute("data-name");
    
    if (activeNavItems.has(navName)) {
      // 如果当前导航项应该高亮，清除之前的延迟取消计时器
      if (deactivateTimers[navName]) {
        clearTimeout(deactivateTimers[navName]);
        delete deactivateTimers[navName];
      }
      
      // 激活所有具有相同 data-name 的导航项
      const allMatchingNavItems = document.querySelectorAll(`[data-name="${navName}"]`);
      
      allMatchingNavItems.forEach((item) => {
        item.classList.add("nav_active");
      });
    } else {
      // 如果导航项不应该高亮，设置延迟移除
      if (navItem.classList.contains("nav_active") && !deactivateTimers[navName]) {
        deactivateTimers[navName] = setTimeout(() => {
          // 移除所有具有相同 data-name 的导航项的激活状态
          const allMatchingNavItems = document.querySelectorAll(`[data-name="${navName}"]`);
          
          allMatchingNavItems.forEach((item) => {
            item.classList.remove("nav_active");
          });
          
          delete deactivateTimers[navName];
        }, 150); // 150ms 延迟
      }
    }
  });
};

// 添加产品到购物车的通用函数
const addProductToCart = async (variantId, quantity = 1) => {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add product to cart");
    }

    return await response.json();
  } catch (error) {
    console.error("Error adding to cart:", error);
    throw error;
  }
};

// 添加到购物车功能
const addToCart = async (variantId, buttonElement) => {
  // 如果没有传入按钮元素，尝试通过 variantId 查找
  if (!buttonElement) {
    buttonElement = document.querySelector(`[data-product-variant-id="${variantId}"]`);
  }
  
  // 保存按钮原始文本
  const originalText = buttonElement ? buttonElement.textContent : "";
  
  try {
    // 设置按钮加载状态
    if (buttonElement) {
      buttonElement.disabled = true;
      buttonElement.classList.add("loading");
      buttonElement.setAttribute("data-original-text", originalText);
      buttonElement.innerHTML = '<span class="button-spinner"></span>Loading...';
    }
    
    await addProductToCart(variantId, 1);
    
    // 获取最新的购物车数据
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();
    
    // 更新购物车数量显示
    const cartCountElements = document.querySelectorAll(".cart-count");
    
    cartCountElements.forEach((element) => {
      element.textContent = cart.item_count;
    });
    
    // 触发购物车更新事件，通知其他组件刷新
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cart,
        },
      })
    );
    
    // 如果存在购物车抽屉，打开它
    const cartDrawer = document.querySelector("cart-drawer");
    
    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
    }
    
    // 备用方案：如果使用的是其他购物车组件
    const cartNotification = document.querySelector("cart-notification");
    
    if (cartNotification && typeof cartNotification.open === "function") {
      cartNotification.open();
    }
  } catch (error) {
    console.error("Add to cart error:", error);
    alert("添加到购物车失败，请重试");
  } finally {
    // 恢复按钮状态
    if (buttonElement) {
      buttonElement.disabled = false;
      buttonElement.classList.remove("loading");
      buttonElement.textContent = originalText;
    }
  }
};

// 将函数暴露到全局作用域，以便在HTML中使用
window.addToCart = addToCart;

// 禁用header吸附功能（仅在有event导航的页面）
const disableHeaderSticky = () => {
  const eventNav = document.querySelector(".event_page_nav");
  
  if (eventNav) {
    const header = document.querySelector(".shopify-section--header");
    
    if (header) {
      header.style.position = "relative";
    }
  }
};

// 初始化
disableHeaderSticky();
bindNavItemEvents();
window.addEventListener("scroll", handleScrollHighlight);